import React from 'react'

export const Estados = ({estado}) => {
    let template;
    switch (estado.toLowerCase()) {
        case 'en proceso':
        case 'pendiente':
            template=<span className="badge badge-light-warning fw-bold me-auto px-4 py-3"><i className="fas fa-clock mr-2"></i>{estado}</span>
        break;

        case 'resuelto':
        case 'resuelta':
          template=<span className="badge badge-light-success fw-bold me-auto px-4 py-3"><i className="fas fa-check mr-2"></i>{estado}</span>
        break;

      
        case 'rechazada':
        case 'rechazado':
          template=<span className="badge badge-light-danger fw-bold me-auto px-4 py-3"><i className="fas fa-times mr-2"></i>{estado}</span>
        break;
    
        default:
            template=<span className="badge badge-light-info fw-bold me-auto px-4 py-3"><i className="fas fa-clock mr-2"></i>{estado}</span>
        break;
    }

  return (
    template
  )
}
